import { rest } from 'msw';
export default rest;
